const React = require("react");

module.exports = React.createContext();
